import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../../client';
import {
  createOrder,
  getOffers,
  getDiscontinueReasons,
  discontinueIntake,
  discontinue,
} from '../../services/smartthermostat/SalesService';

export const useSalesCreateOrder = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(createOrder, 'requestBody', 'data'),
      'data',
      'offerIds',
      'referenceId',
      'deliveryAddress',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['offerIds', 'referenceId', 'deliveryAddress'] },
    ],
  },
);

export const useSalesGetOffers = createMutationHook(
  collapseDataFromCall(collapseParams(collapseParams(getOffers, 'requestBody', 'data'), 'data', 'deviceType')),
  {
    injectables: ['label', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['deviceType'] },
    ],
  },
);

export const useSalesGetDiscontinueReasons = createDCHook(
  'getDiscontinueReasons',
  collapseDataFromCall(getDiscontinueReasons),
  { injectables: ['label', 'businessUnit'], flattenData: true },
);

export const useSalesDiscontinueIntake = createDCHook('discontinueIntake', collapseDataFromCall(discontinueIntake), {
  injectables: ['label', 'customerId', 'businessUnit'],
  flattenData: true,
});

export const useSalesDiscontinue = createMutationHook(
  collapseDataFromCall(
    collapseParams(
      collapseParams(discontinue, 'requestBody', 'data'),
      'data',
      'date',
      'reasonCode',
      'explanation',
      'referenceId',
    ),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['date', 'reasonCode', 'explanation', 'referenceId'] },
    ],
  },
);
